import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Input } from "../Input";
import { SellingStrategyValueInput } from "../SellingStrategyValueInput";
import { DefaultInput } from "../DefaultInput";

interface SpotCountSellingStrategyProps {
    setValues: (value: any, key: string, isUserSelection?: boolean) => void;
    inputValues: any;
    overrideDiscountRate: boolean;
    onOverrideDiscountRateClick: (value: boolean) => void;
}

export const SpotCountSellingStrategy = (props: SpotCountSellingStrategyProps) => {
    const { t } = useTranslation();

    return (
        <>
            <Col className="multipleInputsRow">
                <Input
                    required
                    title={t("txt_spot_count")}
                >
                    {/* <SellingStrategyValueInput
                        disabled={false}
                        iconKey="currency"
                        setValues={(value, key) => props.setValues(value, key)}
                        value={props.inputValues.sellingStrategyValue ? props.inputValues.sellingStrategyValue : 0}
                    /> */}
                    <DefaultInput
                        onChange={(value: any) => props.setValues(parseFloat(value), "fullBudget", true)}
                        type="currency"
                        iconKey="currency"
                        placeholder={t("txt_spot_count")}
                        value={props.inputValues.fullBudget}
                        params={{numberIsInterger: true}}
                    />
                </Input>
            </Col>
            <Col className="multipleInputsRow">
                <Input
                    required
                    title={t("txt_method_discount")}
                    checkbox={{
                        display: true,
                        title: t("txt_custom_rate"),
                        id: 'customRateCheck',
                        checked: props.overrideDiscountRate,
                        onChange: props.onOverrideDiscountRateClick,
                        className: "directAdvertiserCheck"
                    }}
                >
                    <SellingStrategyValueInput
                        setValues={(value, key) => props.setValues(value, key)}
                        disabled={!props.overrideDiscountRate}
                        iconKey="percent"
                        valuekey="discountRate"
                        value={props.inputValues.discountRate ? props.inputValues.discountRate : 0}
                        isPercentage={true}
                    />
                </Input>
            </Col>
        </>
    );
}